import React from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button, Datepicker } from 'components/Misc/Form';

import { useCourseStudentsStore } from 'store/course/useCourseStudentsStore';

const Assignment = ({ modal, onModal }) => {
// Cache current course's id
	const { id } = useParams();

	// Use student store
	const [data, onChange, parameters] = useCourseStudentsStore(state => [
		state.data,
		state.onChange,
		state.parameters
	]);

	// Store request
	const [[progress], request] = useRequest('put', `courses/${id}`);

	// Handle student submition
	const onSubmit = async () => {
		// Try to assign students to course
		const [success] = await request(data, {
			...parameters,
			related: 'students:dates'
		});

		// Reset on success
		if (success) onModal();
	};

	return (
		<Modal title="Rediģēt datumus" visible={modal} handleModal={onModal}>
			<div className="grid grid-cols-2 gap-4">
				<Datepicker
					asInput
					name="startDate"
					label="Sākuma datums"
					value={data.startDate}
					onChange={onChange}
				/>

				<Datepicker
					end
					asInput
					name="endDate"
					label="Beigu datums"
					value={data.endDate}
					onChange={onChange}
				/>

				<div className="col-span-2 flex justify-end">
					<Button
						progress={progress}
						theme="success"
						value="Rediģēt datumus"
						onClick={onSubmit}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Assignment;